import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import { tryGetTopicsSdk } from './tryGetTopicsSdk';

export function isTopicsHighlightEnabled() {
    const configValue =
        getUserConfiguration().UserOptions.IsTopicHighlightsEnabled ??
        isFeatureEnabled('csi-topicHighlightsOnByDefault');
    return isTopicsHighlightFlightEnabled() && configValue;
}

/**
 * Returns true if the topic highlights flight is enabled.
 * This does not include the user settings.
 */
export function isTopicsHighlightFlightEnabled() {
    return isFeatureEnabled('csi-owa-auto-topic-highlights') && isAutomaticTopicsEnabled();
}

export function isTopicsRollupEnabled() {
    return isFeatureEnabled('csi-owa-topic-dropdown') && isTopicsMvpEnabled();
}

export function isAutomaticTopicsEnabled() {
    return isFeatureEnabled('csi-owa-topic-card') && isTopicsMvpEnabled();
}

export function isManualTopicsEnabled() {
    return isFeatureEnabled('csi-owa-topic-manual') && isTopicsMvpEnabled();
}

export function shouldUseTopicsSdk() {
    return isFeatureEnabled('csi-usetopicssdkapi');
}

// Make sure the flight checks happen before any Topics SDK check, to avoid loading the SDK if the flight is off.
export function isTopicsMvpEnabled(): boolean {
    return (
        (isFeatureEnabled('csi-owa-topics-mvp') ||
            (isFeatureEnabled('csi-owa-topics-mvp-preview') &&
                tryGetTopicsSdk()?.isPreviewUser())) &&
        tryGetTopicsSdk()?.canUserViewTopics()
    );
}

/**
 * Returns true if either the regular or preview Topics MVP flight is enabled.
 * Use this only before the topics SDK is available, to load the SDK and then check for the specific feature.
 */
export function isTopicsMvpFlightEnabled(): boolean {
    return isFeatureEnabled('csi-owa-topics-mvp') || isFeatureEnabled('csi-owa-topics-mvp-preview');
}
